// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth} from 'firebase/auth'
import { getFirestore} from 'firebase/firestore';
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAizkyBYB-pnrJ3l5paCPWdVduYpsnMtSo",
  authDomain: "ths-stay-alert.firebaseapp.com",
  databaseURL: "https://ths-stay-alert-default-rtdb.firebaseio.com",
  projectId: "ths-stay-alert",
  storageBucket: "ths-stay-alert.appspot.com",
  messagingSenderId: "574406953370",
  appId: "1:574406953370:web:01f2ba5b7faad5ea735223",
  measurementId: "G-CVCMG35Y3X"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;